{
  "plan_details": {
    "frequency": {
      "annually": "Anualmente",
      "monthly": "Mensalmente",
      "title": "Pague anualmente e economize 10%"
    },
    "choose_currency": "Escolha sua moeda",
    "includes": "O que está incluído:",
    "everything_in": "Tudo em {{ plan }} além de:",
    "per_user": "por usuário/por mês",
    "switch_to": "Mudar para {{ plan }}",
    "upgrade_to": "Atualize para {{ plan }}",
    "manage_plan": "Gerenciar plano",
    "call_us": "Ligue para nós",
    "contact_us": "Entre em contato conosco",
    "title": {
      "part_1": "Escolha o plano perfeito para você e seu",
      "part_2": "Equipe"
    },
    "subtitle": {
      "part_1": "Compare nossos planos e recursos em nosso",
      "part_2": "página de preços",
      "part_3": "ou"
    },
    "plans": {
      "professional": {
        "name": "profissional",
        "prev_plan": "",
        "features": {
          "1": "Planos ilimitados para seu evento",
          "2": "Acesso a uma extensa biblioteca de modelos de camadas",
          "3": "Modelos 3D para visualizar planos com precisão",
          "4": "Atributos para capturar dados, incluindo datas e custos",
          "5": "Espaço de trabalho compartilhado para sua equipe",
          "6": "Camadas e ícones personalizáveis e flexíveis",
          "7": "Ferramentas de análise, incluindo calculadora de capacidade de multidões",
          "8": "Exportações profissionais de PDF",
          "9": "Integração CAD e atualizações ilimitadas",
          "10": "Suporte de integração",
          "11": "Visualizadores ilimitados!"
        }
      },
      "premium": {
        "name": "premium",
        "prev_plan": "profissional",
        "features": {
          "1": "Capture e visualize planos por hora e data",
          "2": "Ferramentas de colaboração, incluindo comentários, marcação, tópicos",
          "3": "Combine planos de diferentes usuários e equipes",
          "4": "Analise quantidades e custos em todo o seu projeto",
          "5": "Exportação de dados geoespaciais em formatos GIS",
          "6": "Serviço de importação de CAD",
          "7": "Suporte de integração personalizado",
          "8": "Visualizadores ilimitados!"
        }
      },
      "enterprise": {
        "name": "empreendimento",
        "prev_plan": "premium",
        "features": {
          "1": "Integração e gerenciamento de contas personalizados",
          "2": "Visualize planos usando gráficos de qualidade de jogo",
          "3": "Planeje usando os mapas 3D da cidade do Google",
          "4": "Publique mapas de marca on-line",
          "5": "Suporte especializado para criar modelos, ícones e modelos 3D",
          "6": "SSO para maior segurança",
          "7": "Suporte 24/7"
        }
      }
    }
  }
}